import { createI18n } from 'vue-i18n'

import en from './locales/en'
import hr from './locales/hr'
import sl from './locales/sl'

export type i18nType = 'en' | 'sl' | 'hr'

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: 'sl',
    fallbackLocale: 'en',
    messages: {
        sl,
        en,
        hr
    },
    availableLocales: ['sl', 'en', 'hr']
})

export default i18n
